export default {
  '/': '/',
  '%': '%',
  logIn: 'Login',
  selectedMonths: 'Selected months',
  forSale: 'For sale',
  soldOut: 'Sold out',
  reportCapacityActiveFilter: 'Showing 1 of 20, filter applied: {skill}',
  countedInCompanyProfit: 'Counted in company profit',
  signingIn: 'Signing in...',
  longSignInMessage: "Hang tight! We're securely logging you in. This may take a moment.",
  total: 'Total',
  key: 'Key',
  value: 'Value',
  buttons: {
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    remove: 'Remove',
    save: 'Save',
    create: 'Create',
    update: 'Update',
    help: 'Help',
    openInNewWindow: 'Open in new window',
    actualNow: 'Mark profile as up to date',
    goToV2: 'Go to v2',
    goToV1: 'Go to v1',
    expandRows: 'Expand rows',
    collapseRows: 'Collapse rows',
    markUpToDate: 'Mark as up to date',
    redirectToProfile: 'Redirect to profile',
    copyToClipboard: 'Copy to clipboard',
    selectAll: 'All',
    selectNone: 'None',
    en: 'EN',
    cs: 'CS',
    close: 'Close',
  },
  filter: {
    search: 'Quick search',
    searchMenu: 'Search in menu (CTRL+K)',
    yes: 'Yes',
    no: 'No',
  },
  toast: {
    success: 'Success',
    error: 'Error',
    itemDidntFound: "Item didn't found",
    copiedToClipboard: 'Copied to clipboard',
  },
  validation: {
    required: 'Value is required',
    before: 'Value is before {name}',
    after: 'Value is after {name}',
    requiredShort: 'Required',
    number: 'Value must be number',
    email: 'Value must be valid e-mail',
    projectNameIsAlreadyTaken: 'Project name is already taken',
    projectAbbreviationIsAlreadyTaken: 'Project abbreviation is already taken',
    emailIsAlreadyTaken: 'E-mail is already taken',
    phoneIsAlreadyTaken: 'Phone is already taken',
    jiraIdIsAlreadyTaken: 'Jira id is already taken',
    noPermissionsForPosition: 'Insufficient permissions for position changes',
    noUniqueOrganizationPosition: 'There must be only one position in the same organization',
    workTypeRequired: 'Work type is required',
    pricePerHourRequired: 'Price per hour is required',
    pricePerHourMustBePositive: 'Price per hour must be greater or equal than 0',
    workedHoursRequired: 'Worked hours is required',
    workedHoursMustBePositive: 'Worked hours must be greater than 0',
  },
  asset: {
    collaboratorSearch: 'Collaborator',
    search: 'Search assets',
    collaborator: 'Collaborator',
    name: 'Name',
    description: 'Description',
    category: 'Category',
    purchasePriceWithoutVat: 'Purchase price (without VAT)',
    purchaseDate: 'Purchase date',
    lifespan: 'Lifespan (months)',
    currentLessee: 'Current lessee',
    currentLesseeName: 'Current lessee',
    owner: 'Collaborator',
    protocolSigned: 'Protocol signed',
    protocols: 'Protocols',
    protocolType: 'Type',
    protocolHandover: 'Handover',
    protocolReturn: 'Return',
    protocolWaitingForSign: 'Waiting for signature',
    protocolReturnWaiting: 'Return waiting',
    protocolState: 'State',
    protocolState_WAITING_FOR_SIGN: 'Waiting for signature',
    protocolState_SIGNED: 'Signed',
    protocolState_REJECTED: 'Rejected',
    protocolState_CANCELED: 'Canceled',
    protocol_handover_signed: 'Handover signed',
    protocol_handover_waiting: 'Handover waiting for signature',
    protocol_handover_rejected: 'Handover rejected',
    protocol_handover_canceled: 'Handover canceled',
    protocol_return_signed: 'Return signed',
    protocol_return_waiting: 'Return waiting for signature',
    protocol_return_rejected: 'Return rejected',
    protocol_return_canceled: 'Return canceled',
    protocolDate: 'Date',
    protocolCollaborator: 'Collaborator',
    protocolDocument: 'Document',
    protocolViewDocument: 'View document',
    note: 'Note',
    create: 'Add new asset',
    edit: 'Edit asset',
    delete: 'Delete',
    saveSuccess: 'Asset saved',
    czk: 'CZK',
    assetNumber: 'Asset number',
    location: 'Location',
    place: 'Place',
    brand: 'Brand',
    uuid: 'UUID',
    categoryName: 'Category',
    locationName: 'Location',
    collaboratorName: 'Collaborator',
    files: 'Files',
    fileNames: 'Files',
    fileUuids: 'File UUIDs',
    fileUploadError: 'Can not save files',
    maxFileErrorMessage: 'You can not add more than 10 files',
    maxFileSizeErrorMessage: 'Max file size is 30MB',
    dropText: 'Drop files here',
    updatedAt: 'Updated at',
  },
  collaboratorStats: {
    namePosition: 'Name/Position',
    internal: 'Internal',
    external: 'External',
    title: 'Collaborators statistics',
    year: 'Year',
    joiners: 'New Joiners',
    leavers: 'Leavers',
    monthlyFluctuation: 'Monthly Fluctuation (%)',
    quarterlyFluctuation: 'Quarterly Gross Fluctuation (%)',
    yearlyFluctuation: 'Yearly Gross Fluctuation (%)',
    total: 'TOTAL',
    totalWithoutBoard: 'TOTAL WITHOUT BOARD',
  },
  bankTransaction: {
    uuid: 'UUID',
    description: 'Description',
    amount: 'Amount (With VAT)',
    amountWithoutVat: 'Amount (Without VAT)',
    amountLeft: 'Amount left on transaction',
    date: 'Date',
    userNotes: 'User notes',
    authorName: 'Author name',
    subjectName: 'Subject name',
    subjectBic: 'Subject BIC',
    subjectAccountNumber: 'Subject account number',
    extra: 'Extra',
    checked: 'Checked',
    companyProfitDate: 'Company profit month',
    minAmount: 'Amount is less than',
    maxAmount: 'Amount is more than',
    bankTransactionDetail: 'Bank transaction detail',
    accountNumber: 'Account number',
    paymentAuthor: 'Payment author',
    author: 'Payment author',
    deductibleVatPercent: 'Deductible VAT %',
    id: 'ID',
    comment: 'Comment',
    orderId: 'Order id',
    type: 'Type',
    partnerNumber: 'Partner number',
    extraInformation: 'Extra information',
    bankTransactionList: 'Bank transaction list',
    constantSymbol: 'Constant symbol',
    lookingForBankTransactions: 'Looking for bank transactions...',
    messageForPartner: 'Message for partner',
    partnerBankAccountNumber: "Partner's bank account number",
    partnerBankBic: "Partner's bank BIC",
    partnerBankCode: "Partner's bank code",
    partnerBankName: "Partner's bank name",
    partnerName: "Partner's name",
    selectedBankAccount: 'Selected bank account',
    specificSymbol: 'Specific symbol',
    split: 'Split',
    splitTransaction: 'Split transaction',
    isTransactionSplit: 'Split transaction',
    thisAccountDoesNotAppearToContainAnyTransactionYet: 'This account does not appear to contain any transactions yet',
    transactionDate: 'Transaction date',
    userIdentification: 'User identification',
    variableSymbol: 'Variable symbol',
    selectInitialDateForSync: 'Select initial date for sync',
    transactionDoesNotContainMoreDetails: "Transaction doesn't contain more details",
    filterBankTransactions: 'Filter bank transactions',
    bankTransactionCostCategory: 'Cost category',
    searchBankTransActions: 'Search bank transactions',
    selectAllBankAccounts: 'Select all bank accounts',
    costCategories: 'Cost categories',
    bankAccount: 'Bank account',
    dateRangeFilter: 'Date range filter',
    transactionDateRange: 'Transaction date range',
    costCategory: 'Cost category',
    bankAccountLoadError: 'Could not load bank accounts',
    getRowsError: 'Could not load bank transactions',
    findBankAccountIdError: 'Could not find id of a bank account',
    findCostCategoryIdError: 'Could not find id of a cost category',
    transactionUpdateError: 'There was a problem while updating the transaction',
    getBankTransactionDetailsError: 'Could not load bank transaction details',
    currency: 'Currency',
    companyCalculationDate: 'Company calculation date',
  },
  collaboratorSkills: {
    name: 'Name',
    position: 'Position',
    skillValuesUpdatedAt: 'Updated at',
    addNewSkill: 'Add new',
    levels: {
      none: 'None',
      low: 'Low',
      medium: 'Medium',
      high: 'High',
      extreme: 'Extreme',
    },
    profileOutdatedBannerDays: "Don't forget to check the collaborator's profile — last update was {days} days ago.",
    profileOutdatedBannerNever: "This collaborator's profile has never been updated.",
    openProfile: 'Open profile',
  },
  costCategories: {
    wages: 'Wages',
    outsource: 'Outsource',
    hr_internal: 'HR internal',
    hr_external: 'HR external',
    equipment: 'Equipment',
    infrastructure_internal: 'Infrastructure internal',
    infrastructure_external: 'Infrastructure external',
    administration: 'Administration',
    sales: 'Sales',
    rtsg: 'RTSG',
    other: 'Other',
    office: 'Office',
    vat: 'VAT',
    notCategorized: 'Not categorized',
    getDataError: 'Could not get cost categories data',
  },
  workLogAnalysis: {
    issuesStatistics: 'Issues statistics',
    actions: 'Actions',
    fullName: 'Name',
    filterDates: 'Filter dates',
    selectWorkLogIssueState: 'Select issue status',
    selectWorkLogIssueType: 'Select issue type',
    selectProject: 'Select project',
    collaboratorSearch: 'Collaborator',
    ticketKey: 'Key',
    ticketTitle: 'Ticket title',
    collaborator: 'Collaborator',
    updatedAt: 'Work log updated',
    workedAt: 'Work start time',
    loggedTime: 'Logged time',
    issueType: 'Issue type',
    issueStatus: 'Issue status',
    createdAt: 'Work log created',
    help: {
      syncText: 'WorkLogs issues are synced every 10 minutes.',
      openJiraTicket: 'You can open jira ticket by clicking on ticket key in table.',
      logTimeFormats: 'Logged time: 1w = 5d, 1d = 8h, 1h = 60m',
    },
    markIssueAsResolved: 'Mark issue as resolved',
    markIssueAsNew: 'Mark issue as new',
    fetchDataError: 'Could not load table data',
  },
  estimateAnalysis: {
    title: 'Estimate Analysis',
    ticketKey: 'Ticket key',
    md: 'MD',
    filterDateFrom: 'From',
    filterDateTo: 'To',
    filterDates: 'Filter dates',
    status: 'Status',
    resolved: 'Resolved',
    unresolved: 'Unresolved',
    selectProject: 'Select project',
    projectStatus: 'Project status',
    ticketStatus: 'Ticket status',
    all: 'All',
    active: 'Active',
    inactive: 'Inactive',
    showOnlyActiveProjects: 'Show only active projects',
    selectCollaborator: 'Select collaborator',
    ticketsTab: 'Tickets',
    dashboardTab: 'Dashboard',
    projectName: 'Project',
    key: 'Ticket key',
    ticketTitle: 'Ticket title',
    collaborator: 'Collaborator',
    resolvedAt: 'Ticket resolved at',
    updatedAt: 'Ticket updated at',
    issueType: 'Ticket type',
    estimateMD: 'Estimate MDs',
    loggedMD: 'Logged time MDs',
    ratio: 'Ratio (%)',
    ticketCount: 'Tickets',
    avgRatio: 'Avg ratio',
    ratioPercentage: 'Ratio (%)',
    byProjectTitle: 'Tickets by Project',
    byCollaboratorTitle: 'Tickets by Collaborator',
    histogramTitle: 'Distribution of estimates vs. logged time',
    histogramDescription: 'Ticket distribution by ratio',
    noData: 'No data available',
    kpi: {
      totalTickets: 'Tickets',
      totalEstimateMD: 'Total estimates',
      totalLoggedMD: 'Total logged time',
      weightedAverageRatio: 'Total ratio (%)',
    },
  },
  collaboratorCost: {
    month: 'Month',
    history: 'Collaborator costs history',
    help: {
      buttonsOfRow: 'Buttons of row',
      buttons: {
        edit: 'Edit - edit selected row',
        copy: 'Copy - copy selected row from previous month',
      },
      valuesCopying:
        'First day of every month, values for all collaborators are copied from previous month to current one.',
      totalCostsPerHour:
        'Total costs per hour = total wage cost per hour + (sum operation cost per month / sum working days for collaborators on project per month)',
      maxDppWorkloadHours: '1 FTE = 28h',
    },
    editTitle: 'Collaborator cost',
    collaborator: {
      firstName: 'First name',
      lastName: 'Last name',
      position: 'Position',
    },
    setFromMonth: 'Set costs from month',
    setToMonth: 'Set costs to month',
    wageSendingCostsPerMonth: 'Wage sending costs per month',
    totalWageCostsPerHour: 'Total wage costs per hour',
    totalCostsPerHour: 'Total cost per hour',
    primaryLegalType: 'Primary legal type',
    primaryLegalTypeWithNote: 'Primary legal type (used for projects profit calculation)',
    workloadHours: 'Workload hours',
    hppWorkloadHours: 'HPP - Workload hours',
    dppWorkloadHours: 'DPP - Workload hours',
    zlWorkloadHours: 'ZL - Workload hours',
    hppFullTimeEquivalent: 'HPP - Full time equivalent',
    dppFullTimeEquivalent: 'DPP - Full time equivalent',
    zlFullTimeEquivalent: 'ZL - Full time equivalent',
    grossWagePerMonth: 'Gross wage per month',
    hppGrossWagePerMonth: 'HPP - Gross wage per month',
    grossWagePerHour: 'Gross wage per hour',
    dppGrossWagePerHour: 'DPP - Gross wage per hour',
    zlGrossWagePerHour: 'ZL - Gross wage per hour',
    standardBonus: 'Standard bonus',
    hppStandardBonus: 'HPP - Standard bonus',
    dppStandardBonus: 'DPP - Standard bonus',
    zlStandardBonus: 'ZL - Standard bonus',
    oneTimeBonus: 'One time bonus',
    hppOneTimeBonus: 'HPP - One time bonus',
    dppOneTimeBonus: 'DPP - One time bonus',
    zlOneTimeBonus: 'ZL - One time bonus',
    vacationDayCount: 'Vacation day count',
    hppVacationDayCount: 'HPP - Vacation day count',
    mealVoucherCosts: 'Meal voucher costs',
    hppMealVoucherCosts: 'HPP - Meal voucher costs',
    filterDateMonth: 'Collaborator cost date month',
    edit: 'Edit collaborator cost',
    copy: 'Copy collaborator cost',
    previousMonthValuesNotFound: 'Previous month values not found',
    search: 'Search collaborator costs',
    formIsNotValid: 'Form is not valid',
    collaboratorPositions: 'Collaborator positions',
    getListError: 'Could not get collaborator cost list',
    getCollaboratorPositionsError: 'Could not get collaborator positions',
    fullTimeEquivalent: 'Full-time equivalent (FTE)',
    fullTimeEquivalents: {
      FTE_1: '1',
      FTE_0_5: '0.5',
      FTE_0: '0',
    },
  },
  collaboratorWorkPlan: {
    firstName: 'First name',
    lastName: 'Last name',
    position: 'Position',
    saveCollaboratorWorkPlan: 'Save collaborator work plan',
    sumPlannedCountedInAverageCostsPerHour: '∑ included in planned average costs per hour:',
    workDaysMD: 'Working MD',
    paidVacationMD: 'Vacation MD',
    unpaidVacationMD: 'Unpaid vacation MD',
    lookingForCollaboratorWorkPlans: 'Looking for collaborator work plans...',
    noCollaboratorWorkPlan: 'No collaborator work plan...',
    countInAverageCostPerHour: 'Include in average cost per hour',
    filterDateMonth: 'Collaborator work plan date month',
    workDaysSumInMD: '∑ planned working:',
    paidVacationSumInMD: '∑ planned vacation:',
    unpaidVacationSumInMD: '∑ planned unpaid vacation:',
    countableForAverageOperationCosts: '∑ of countable for average operating costs:',
    MD: 'MD',
    hour: 'h',
    successSaved: 'Values ​​saved successfully',
    baseWorkingMD: 'Base working MD',
    plannedWorkingMD: 'Planned working MD',
    plannedVacationMD: 'Planned vacation MD',
    plannedUnpaidVacationMD: 'Planned unpaid vacation MD',
    realWorkingMD: 'Real working MD',
    realVacationMD: 'Real vacation MD',
    realUnpaidVacationMD: 'Real unpaid vacation MD',
    includedInProjectPlan: 'Count in average operating cost',
    setBaseWorkingMd: 'Set base working days for all in current month',
    baseWorkingDaysDialog: {
      title: 'Do you want to set base working days?',
      text: 'Base working days will be set for all collaborators in the chosen month.',
    },
    baseWorkingDaysSuccessSaved: 'Base working days have been set for all collaborators.',
  },
  projectPlan: {
    save: 'Save project plan',
    saveTitle: 'Save',
    planSaved: 'Project plan saved',
    planNoteUpdated: 'Project note updated',
    salesNoteNeedsToBeUpdated: 'Sales note needs to be updated',
    salesManagerNotSet: 'Sales manager not set',
    salesManagerTooltip: 'Sales manager: {name}',
    projectCoordinatorTooltip: 'Project coordinator: {name}',
    salesManagerShort: 'SM:',
    projectCoordinatorShort: 'PC:',
    projectLeadShort: 'PL:',
    projectLeadTooltip: 'Project lead: {name}',
    legendTooltipTitle: 'Color meanings:',
    legendOrange: 'Orange: last order ends in less than 30 days',
    legendRed: 'Red (Link hover): order already ended',
    legendGreen: 'Green (Link hover): order is upcoming',
    legendDefault: 'White / default (Link hover): order currently running',
    legendBriefOrange: 'ends <30d',
    legendBriefRed: 'ended',
    legendBriefGreen: 'upcoming',
    legendBriefRunning: 'running',
    updatedBySomeoneElse: 'Data has been updated by someone else, please refresh the page.',
    table: {
      occupancy: {
        label: 'Occupancy',
        billable: 'Billable',
        billableTooltipValues: '({totalBillable} / {totalAvailableCapacity}) * 100 = {percentageResult}',
        billableTooltipDescription: '(∑ billable planned work / ∑ collaborators available capacity) * 100',
        planned: 'Planned',
        plannedTooltipValues: '({totalPlanned} / {totalAvailableCapacity}) * 100 = {percentageResult}',
        plannedTooltipDescription: '(∑ all planned work / ∑ collaborators available capacity) * 100',
        availableCapacity: 'MD left',
      },
      project: {
        label: 'Project',
        requiredCapacity: 'Required capacity',
        requiredCapacityAbbreviation: 'Req. cap.',
        projectHasNoOrderForThisMonth: 'Project has no order for this month',
        projectOrderHaveNotClientSignDateForThisMonth: 'Some project orders do not have client sign date',
        orderEndingSoon: 'Last order ends in {days} days',
        orderValidity: 'Valid: {from} – {to}',
        orderNextValidity: 'Next: {from} – {to}',
        orderGap: 'Gap: {days} days',
        orderState: {
          running: 'Order running',
          ended: 'Order ended',
          upcoming: 'Order upcoming',
          none: 'No order',
        },
        totalCapacityTooltip: '∑ {total} MD',
        percentageCapacityTooltip: '{perc}% ({required}/{total})',
        orderLink: 'Orders',
        categories: {
          INTERNAL: 'Internal project',
          OUTSOURCE: 'Outsource project',
          INHOUSE: 'In house project',
        },
      },
      collaborator: {
        label: 'Collaborator',
        position: 'Position',
        availableCapacity: 'Available capacity',
        categories: {
          INTERNAL_EMPLOYEE: 'Internal collaborator',
          EXTERNAL_EMPLOYEE: 'External collaborator',
        },
      },
      unusedCapacity: {
        label: 'Unused capacity',
      },
      internalLabel: 'Internal project',
      manager: 'Manager',
    },
    help: {
      projectItems: 'Table shows projects which are active.',
      collaboratorItems: 'Table shows collaborators which are included in project planning by their position.',
      overCapacity: "Capacity can go over it's limit, e.g.: a collaborator worked overtime.",
    },
    noSkillsInfo: 'No skills filled in',
    datePicker: 'Project plan month',
    sendNotification: 'Send notification',
  },
  operatingCost: {
    sumLabel: 'SUM:',
    totalCostsPerHourLabel: 'Total costs per hour:',
    workHours: 'Work hours:',
    editHours: 'Edit',
    deleteItem: 'Delete item',
    datePickerLabel: 'Operating cost month',
    items: 'Items',
    table: {
      name: 'Cost name',
      value: 'Value',
    },
    itemCreated: 'Item created',
    itemUpdated: 'Item updated',
    itemDeleted: 'Item deleted',
    itemsCopied: 'Items copied',
    copy: 'Copy',
    copyTooltip: 'Copy all from last month',
    copyDialog: {
      title: 'Do you really want to copy?',
      text: 'The selected month will be replaced by items from the last month.',
    },
    help: {
      copy: 'Copying from the last month will replace the current month items.',
      update: 'Item will be updated automatically after navigating out from the fields.',
      create: 'After filling all fields, item can be created by pressing a key Enter.',
    },
  },
  costsPlanning: {
    plannedCostPerWorkHours: 'Avg. planned cost per work h.',
    plannedWorkHours: 'Planned work hours',
    datePicker: 'Year',
    save: 'Save',
    import: 'Import',
    exportCsv: 'Export csv',
    categoryName: 'Category name',
    subCategoryName: 'Sub-category name',
    yearSum: 'Year sum',
    sumOfMonth: 'Planned costs per month',
    costPlanSaved: 'Cost plan saved',
    cannotSaveCostPlan: "Can't save cost plan. Try again later",
    unsavedChangesAlert: 'Unsaved changes',
    importDialog: {
      title: 'Import costs',
      spreadsheetUrl: 'Spreadsheet url',
      sheetName: 'Sheet name',
      importMonths: 'Selected months',
      previewImport: 'Preview import',
      executeImport: 'Execute import',
      getImportError: 'Import from google spreadsheet failed',
      saveImportedDataError: 'Saving imported data failed',
      saveImportedDataSuccess: 'Saving imported data was successful',
      hideErrors: 'Hide Errors',
      showErrors: 'Show Errors',
      all: 'All',
      unmatchedExistingData: 'Unmatched Existing Data Subcategories',
      unmatchedImportedData: 'Unmatched Imported Data Subcategories - BLOCKS IMPORT',
    },
  },
  companyProfit: {
    category: {
      name: 'Cost category',
    },
    getListError: 'Could not get company profit list',
    noNonEmptyCostSubCategories: 'There are no non empty cost subcategories for cost category: ',
    countInCompanyProfit: 'Count in profit',
    notCountInCompanyProfit: 'Not counted in profit',
    includedInCompanyProfit: 'Included in profit',
    investmentCostsDiff: '∑ Cost diff',
    costsBalance: '∑ Real costs',
    totalPlannedCost: '∑ Planned costs',
    plannedCost: 'Planned costs',
    realCost: 'Real costs',
    realCostTooltip: 'Sum by bank transactions',
    realCostIncludedInCompanyProfit: 'Real costs included in profit',
    correction: 'Cost corrections',
    correctionIncludedInCompanyProfit: 'Cost corrections included in profit',
    correctionTooltip: 'Pozitivní hodnota znamená větší náklady, negativní znamená menší náklady',
    costDiff: 'Cost difference',
    datePickerLabel: 'Company profit month',
    companyProfit: 'Company profit',
    cumulativeCompanyProfit: 'Cumulative company profit',
    projectsProfit: '∑ Projects profit',
    invoiceRevenues: '∑ Invoice revenues',
    projectsRevenues: 'Revenue',
    notCategorizedAmount: 'Not categorized costs',
    profitCorrection: '∑ Corrections (WITHOUT cost category)',
    noteCorrection: 'Note & correction',
    virtualCorrection: 'Calculated correction for transaction split',
    help: {
      projectsProfit: 'Suma profitů všech projektů',
      totalPlannedCost: 'Suma plánovanách nákladů',
      companyProfit: 'Profit společnosti',
      totalCosts: 'Suma nákladů počítaných do kalkulace, dle bankovních transakcí',
      investmentCostsDiff:
        'Rozdíl mezi plánovanými a reálnými náklady, minusová hodnota znamená, že jsme utratili méně, plusová, že jsme utratili více, než bylo v plánu. Včetně korekcí s cost category',
      countProjectsProfits:
        'company profit = ∑(planned costs) - ∑(real costs) + ∑(corrections WITH cost category) + ∑(project profits) + ∑(corrections WITHOUT cost category)',
      countInvoiceRevenues:
        'company profit = - ∑(real costs) + ∑(corrections WITH cost category) + ∑(invoice revenues) + ∑(corrections WITHOUT cost category)',
      sumCorrectionsWithCostCategory:
        'Součet korekcí s kategorií, jak těch manuálně zadaných, tak splity bankovních transakcí',
      sumCorrectionsWithoutCostCategory: 'Součet korekcí bez kategorií',
      sumProjectRevenues: 'Suma příjmů na projektech, zadaných v kalkulacích projektů',
      invoiceRevenues:
        'Suma fakturovaných částek v daném měsící dle DUZP bez DPH. EUR faktury jsou přepočítány dle kurzu ČNB pro daný den',
    },
    sumCorrectionsWithCostCategory: '∑ Corrections (WITH cost category)',
    costs: 'Costs',
    revenues: 'Revenues',
    sumProjectRevenues: '∑ Projects revenues',
    profit: 'Profit',
    profitModel: 'Profit model',
    companyProfitNoteDialog: {
      value: 'Value',
      actions: 'Actions',
      bankTransactionSplitInfo: 'Correction for bank transaction: {id}',
    },
    bankTransactionsDialog: {
      name: 'Bank transactions',
      filterByCategory: 'Filter by category',
      allCategories: 'All',
    },
    correctionsDialog: {
      header: 'Corrections',
      name: 'Name',
      value: 'Value',
      category: 'Category',
    },
    countProjectsProfits: 'PROJECTS profits',
    countInvoiceRevenues: 'INVOICES revenues',
    count: 'Count',
    profits: 'Profits',
  },
  projectCalculation: {
    ftfp: 'FTFP',
    ftfpOrders: 'FTFP orders',
    ftfpRevenueTooltip: 'Fixed price (FTFP) – this row is generated automatically and cannot be edited.',
    ftfpAmountForMonth: 'Amount for {month}',
    ftfpTotalPrice: 'Total',
    ftfpRemaining: 'Remaining',
    ftfpAmountExceedsRemaining: 'The total would exceed the order price, at most {max} CZK is left',
    ftfpReduceFirstMonthFirst:
      'Order "{description}" still holds its whole amount in {month}. Reduce it there first, then part of ' +
      'it can be allocated to this month.',
    ftfpReduceFirstMonthFirstError: 'Reduce the amount in {month} first – there is 0 CZK left to allocate.',
    ftfpRateUnavailable: 'No rate found for {currency} on {date}. Try again later.',
    ftfpFutureMonthNotAllocatable: "Can't allocate a {currency} order into a future month – no rate yet.",
    validity: 'Validity',
    totalBilledFtfpTooltip: 'Only T&M rows are counted towards Total billed.',
    edit: 'Edit project',
    timeCorrection: 'Time correction [h]',
    selectedProject: 'Selected project',
    costs: 'Costs from logs',
    additionalCosts: 'Additional costs',
    revenues: 'Revenues',
    grossProfitCZK: 'Gross profit',
    grossProfitTooltip:
      'Gross profit excluding budget plan overruns, vacancy corrections, reserves creation, and similar.',
    grossProfitPercent: 'Gross profit %',
    discountCZK: 'Discount CZK',
    month: 'Selected month',
    projectRevenues: 'Project revenues',
    workType: 'Work type',
    description: 'Description',
    pricePerHour: 'Price per hour',
    workedTime: 'Worked hours',
    ticketKey: 'Key',
    ticketTitle: 'Title',
    timeSpendInHours: 'Time spend [h]',
    workedHoursSum: 'Worked sum [h]',
    costPerHour: 'Cost per hour',
    totalCollaboratorCost: 'Total cost',
    calculationUpdated: 'Calculation updated',
    revenueSaved: 'Revenue saved',
    revenueDeleted: 'Revenue deleted',
    noWorkLogs: 'No worklogs logged',
    totalWorked: 'Total worked',
    totalWorkedShort: 'Total worked',
    totalBilled: 'Total billed',
    totalWorkedWithCorrection: 'Total worked with correction',
    totalWorkedWithCorrectionShort: 'Total worked w. corr.',
    moveTicketToProject: 'Move ticket to project',
    searchProject: 'Search project...',
    noProjectsFound: 'No projects found',
    ticketMoved: 'Ticket moved',
    from: 'from:',
    to: 'to:',
    setOriginalProject: 'Set original project',
    reportSend: 'Report sent',
    reportApproved: 'Report approved',
    invoiceSent: 'Invoice sent',
    billingStatus: 'Billing status',
    projectManager: 'Project manager',
    noProjectManager: 'No Project manager',
    projectCoordinator: 'Project coordinator',
    noProjectCoordinator: 'No Project coordinator',
    projectLead: 'Project lead',
    noProjectLead: 'No Project lead',
    note: 'Note',
    locked: 'Locked',
    notCountThisTicketInCalculation: 'Not count this ticket in calculation',
    countThisTicketInCalculation: 'Count this ticket in calculation',
    price: 'Price',
    priceTooltip: 'Price without VAT',
    total: 'Total',
    copyToClipboardWithoutWorkType: 'Copy to clipboard without work type',
    deleteThisRevenue: 'Delete this revenue',
    createNewRevenue: 'Create new revenue',
    generateReport: 'Generate report',
    copyRevenuesFromLastMonth: 'Copy revenues from last month',
    revenuesCopied: 'Revenues copied',
    noRevenuesToCopy: 'There is no revenues to copy from last month',
    projectCalculationLocked: 'Project calculation is locked',
    workLogs: 'Worklogs detail for project {projectName}, user {collaboratorName} at {selectedDate}',
    workLogsDialog: {
      date: 'Date',
      spentTime: 'Logged time',
      ticket: 'Ticket',
      summary: 'Description',
      collaborator: 'Collaborator',
    },
    save: 'Save',
    recordUnsavedChanges: 'This record has unsaved changes',
    sectionUnsavedChanges: 'This section has unsaved changes',
    revenuesSaved: 'Changes in Project revenues saved',
    totalCollaboratorCostDetailed: 'Total collaborator cost',
    cannotCreateRevenue: 'Cannot create revenue: {errors}',
    dataCannotBeSaved: 'Data cannot be saved. It contains errors: {errors}',
    collaboratorRates: 'Collaborator rates',
    collaborator: 'Collaborator',
    diff: 'Diff',
    noOrdersFound: 'No sales orders found for the selected project and month',
    noCollaborators: 'No collaborators found',
    maxHoursExceeded: 'Maximum {max} hours allowed',
    ratesLoadError: 'Rates failed to load',
    ratesSaveError: 'Rates failed to save',
    ratesSaveSuccess: 'Rates saved successfully',
    pricePerMdFormat: '{price}/MD',
    orders: 'Orders',
    collaboratorWorkedHours: 'Collaborator worked hours',
    dateRange: '{from} — {to}',
    pricePerMd: 'Price per MD',
    addWorkType: 'Add work type',
    selectWorkType: 'Select work type',
    hours: 'Hours',
    removeWorkType: 'Remove work type column',
  },
  projectOverallCalculation: {
    getListError: 'Could not get project list',
    showZeroProfitProjects: 'Show zero profit projects',
    type: 'Type',
    category: 'Category',
    averageProfit: 'Average projects profit',
    filterDateMonth: 'Month',
    costs: 'Costs CZK',
    revenues: 'Revenues CZK',
    profit: 'Profit CZK',
    profitInPercentage: 'Profit %',
    sumProfit: 'Σ profit:',
    sumWorkedTime: 'Σ worked time:',
    sumRevenues: 'Σ revenues:',
    workedTimeInSec: 'Worked hours',
    billedTimeInSec: 'Billed hours',
    billingStatus: 'Billing status',
    projectManager: {
      name: 'Project manager',
    },
    projectCoordinator: {
      name: 'Project coordinator',
    },
    salesManager: {
      name: 'Sales manager',
    },
    locked: 'Locked',
    calculations: 'Calculations',
  },
  salesProjectsStatistics: {
    sumRevenues: 'SUM revenues:',
    filterDateMonth: 'Month',
    revenues: 'Revenues',
    clientName: 'Client name',
    reportSent: 'Report send',
    showZeroProfitProjects: 'Show zero profit projects',
  },
  hour: 'Hour',
  hours: 'hours',
  help: 'Help',
  name: 'Name',
  description: 'Description',
  actions: 'Actions',
  firstName: 'First name',
  lastName: 'Last name',
  email: 'E-mail',
  password: 'Password', // eslint-disable-line sonarjs/no-hardcoded-passwords
  userGroup: 'User group',
  role: 'Role',
  icon: 'Icon',
  home: 'Home',
  logout: 'Logout',
  openInNewWindow: 'Open in a new window',
  loginWithGoogle: 'Login with Google',
  login: 'LOG IN',
  loginError: 'Login error - please check credentials',
  order: 'Order',
  pickIconFrom_url_: 'Pick icon from {0}.',
  link: 'Link',
  category: 'Category',
  canView: 'Can view',
  canEdit: 'Can edit',
  dataWillBeSynchronizedFromGoogleAfterFirstLogin:
    'First name, last name and avatar will be synchronized from Google after first login',
  token: 'Token',
  projectsList: 'Projects',
  amount: 'Amount',
  type: 'Type',
  comment: 'Comment',
  author: 'Author',
  currency: 'Currency',
  czk: 'CZK',
  sync: 'Sync',
  dash: '-',
  permissions: 'User permissions',
  dateRange: 'Date Range',
  textEditor: {
    bold: 'Bold',
    italic: 'Italic',
    strike: 'Strike',
    underline: 'Underline',
    code: 'Code',
    paragraph: 'Paragraph',
    heading1: 'Heading 1',
    heading2: 'Heading 2',
    heading3: 'Heading 3',
    bulletList: 'Bullet list',
    orderList: 'Order list',
    codeBlock: 'Code block',
    horizontalRule: 'Horizontal rule',
    undo: 'Undo',
    redo: 'Redo',
  },
  organization: {
    name: 'Organization name',
    url: 'Organization URL',
    create: 'Create new organization',
    delete: 'Delete organization',
    edit: 'Edit organization',
    active: 'Active',
    managed: 'Managed',
    search: 'Search organizations',
    saveSuccess: 'Organization saved',
    deleteSuccess: 'Organization deleted',
    deleteOrganization: 'Delete Organization',
    organizationExistsError: 'Organization with this name or code or URL already exists',
    crmLink: 'CRM link',
    projects: 'Projects',
    code: 'Code',
    organizationIsManaged: 'Organization is managed',
    id: 'Organization ID',
    uuid: 'Organization UUID',
    supplier: 'Supplier',
    customer: 'Customer',
    identificationNumber: 'Identification number',
  },
  collaborator: {
    personalSection: 'Personal',
    companySection: 'Company',
    profileSection: 'Profile',
    positions: 'Positions',
    collaborators: 'Collaborators',
    collaboratorProfile: 'Collaborator Profile',
    create: 'Create new collaborator',
    search: 'Search collaborator',
    positionSelect: 'Select positions',
    edit: 'Edit collaborator',
    firstName: 'First name',
    warningsCol: 'Warnings',
    lastName: 'Last name',
    generatedId: 'Id',
    uuid: 'UUID',
    privateEmail: 'Private e-mail',
    workEmail: 'Work e-mail',
    hrNotes: 'HR Notes',
    insuranceCompany: 'Insurance company',
    contactPersonPhone: 'Contact person name + phone number',
    companyIdentificationNumber: 'IČO',
    contactsAddress: 'Contacts address',
    phone: 'Phone',
    birthdate: 'Birthdate',
    permanentResidence: 'Permanent residence / Business address',
    personalIdentificationNumber: 'Personal identification number',
    education: 'Education',
    profileUrlUpdatedAt: 'Last profile url update',
    updatedByAndWhen: 'Updated {date} by {collaborator}',
    needsToBeUpdated: 'Profile needs to be updated, last change is older than 3 months',
    profileDoesntExist: "Collaborator profile doesn't exist",
    confirmProfileUpToDate: {
      title: 'Collaborator Profile is outdated',
      confirm: 'Mark profile as up to date',
      success: 'Profile marked as up to date',
    },
    position: {
      name: 'Position',
    },
    organization: {
      name: 'Organization',
    },
    legalType: 'Druh smlouvy',
    BOZP: 'BOZP',
    bankAccountNumber: 'Bank account number',
    workStart: 'Work start',
    workEnd: 'Work end',
    jiraId: 'Jira id',
    organizations: 'Organizations',
    lookingForCollaborators: 'Looking for collaborators...',
    noCollaboratorYet: 'No collaborator yet.',
    saveSuccess: 'Collaborator saved',
    saveSkillsSuccess: 'Collaborator skills saved',
    deleteSuccess: 'Collaborator deleted',
    deleteFailed: 'Collaborator delete failed',
    editCollaboratorSkills: 'Edit collaborator skills',
    removeCollaboratorSkill: 'Remove collaborator skill',
    addCollaboratorSkill: 'Add collaborator skill',
    editCollaborator: 'Edit collaborator',
    deleteCollaborator: 'Delete collaborator',
    userIdentities: 'User identities (ticket systems)',
    collaboratorSkillSlider: {
      min: '5 is the worst',
      max: '1 is the best',
    },
    noSkillFound: 'No skill with value 1 to 4 found for collaborator',
    assets: 'Collaborator assets',
    fullName: 'Full name',
    profileUrl: 'Profile URL',
    activeCollaborators: 'Active collaborators',
    active: 'Active',
    leavingChecklist: 'Leaving Checklist',
    warnings: {
      title: 'Collaborator warnings',
      shouldHaveBozp: 'Should have BOZP',
      shouldHaveBaseWorkingDaysCountForCurrentMonth: 'Should have base working days for current month',
      shouldHaveCostForCurrentMonth: 'Should have collaborator cost for current month',
      hasUndoneLeavingChecklistItems: 'Has undone leaving checklist items',
      isActiveButHasWorkEndInThePast: 'Is active, but has work end in the past',
      shouldHaveMatchingLegalType: 'Should have matching legal type for current month',
    },
    type: 'Type',
    types: {
      INTERNAL: 'Internal',
      EXTERNAL: 'External',
    },
    generateLeavingChecklist: 'Generate leaving checklist',
    leavingChecklistDialog: {
      title: 'Generate leaving checklist',
      text: 'Are you sure you want to reset current leaving checklist?',
    },
    responsiblePerson: 'Responsible person',
    markSkillsUpToDateSuccess: 'Skills were successfully marked as up to date',
    requiredFields: 'Required fields are marked by: ',
    activeTooltip: `Dopady deaktivace collaboratora
------------------------------------------------------
ERP
- Vyřazuje neaktivní collaboratory z pracovních plánů
- Nezobrazuje varování o chybějících nákladech u neaktivních uživatelů
- Filtruje neaktivní collaboratory v collaborator listu
- Bude zobrazovat warningy u neaktivních collaboratorů, kteří nemají splněný výstupní checklist

HUB
- The Game: zabraňuje udělování experience bodů neaktivním collaboratorům
- Slack integrace: ignoruje při týdenním zasílání feedbacku, vynechává při aktualizaci avatarů
- Feedback systém: neaktivní uživatelé nejsou zahrnuti do feedback heat mapy ani do poznámek
`,
    collaboratorIdentities: 'Ticket systems identities',
    externalId: 'External ID',
    externalIdsUpdated: 'External IDs were updated',
    skillsNotice: 'Skills (not displaying skills with value 5)',
  },
  collaboratorNotes: {
    editCollaboratorNotes: 'Edit collaborator notes',
    enterYourNote: 'Enter your note ...',
    deleteSuccess: 'Note deleted',
    saveSuccess: 'Note saved',
    buttons: {
      addNote: 'Add note',
    },
  },
  project: {
    name: 'Project name',
    status: 'Project status',
    abbreviation: 'Project abbr',
    category: 'Category',
    type: 'Type',
    organization: {
      name: 'Organization name',
    },
    uuid: 'Uuid',
    projectInfo: 'Project info',
    projectTools: 'Project tools',
    paidActivities: 'Paid activities',
    techFides: 'TechFides',
    client: 'Client',
    billing: 'Billing',
    projectManager: {
      name: 'Project manager',
    },
    projectCoordinator: {
      name: 'Project coordinator',
    },
    projectLead: {
      name: 'Project lead',
      tooltip:
        'Only someone who meets at least the medior level in leadership within the DBG standards can be a Project leader',
    },
    salesManager: {
      name: 'Sales manager',
    },
    responsibleManager: 'Responsible manager',
    billingData: 'Billing data (address, VAT number etc.)',
    billingInfo: 'Billing info (notes)',
    billingEmails: 'Billing emails',
    billingParameters: 'Billing parameters',
    reporting: {
      heading: 'Reporting',
      monthly: 'Monthly',
      weekly: 'Weekly',
    },
    plannedHours: 'Planned hours',
    dueInDays: 'Due in days',
    firstReminder: 'First reminder',
    nextReminder: 'Next reminder',
    internal: 'Internal',
    external: 'External',
    inHouse: 'InHouse',
    outsource: 'Outsource',
    active: 'Active',
    search: 'Search projects',
    create: 'Create new project',
    edit: 'Edit project',
    delete: 'Delete project',
    crmLink: 'CRM link',
    devLead: 'Dev lead',
    section: {
      projectInfo: 'Project info',
      roles: 'Roles',
      billing: 'Billing',
      settings: 'Settings',
    },
    projectMainGoal: 'Main goal',
    projectMainRisks: 'Main risks',
    analysisPaid: 'Analysis',
    developPaid: 'Develop',
    testingPaid: 'Testing',
    projectManagementPaid: 'PM',
    collaborationType: 'Collaboration type',
    ticketSystem: 'Ticket system',
    gitRepository: 'GIT repository',
    communicationTools: 'Communication tools',
    documentationLink: 'Documentation link',
    otherProjectNotes: 'Notes',
    collaborationTypeItem: {
      TIME_AND_MATERIAL: 'Time & Material',
      FIX_PRICE: 'Fix price',
    },
    noteForThisMonth: 'Note for this month',
    saveSuccess: 'Project saved',
    orders: 'Orders',
    invoices: 'Invoices',
    contacts: 'Contacts',
    deleteProject: 'Delete project',
    deleteSuccess: 'Project deleted',
    areYouSureToDelete: 'Are you sure you want to delete this project?',
    noProjects: 'You either have no projects or insufficient permissions to view projects',
    projectIdentities: 'Project identities',
    externalId: 'External ID',
    externalIdsUpdated: 'Project external IDs updated successfully',
    failedToLoadProjectIdentities: 'Failed to load project identities',
  },
  projectContacts: {
    name: 'Name',
    phone: 'Phone',
    email: 'Email',
    position: 'Position',
    notes: 'Notes',
    contactCreated: 'Contact created',
    contactUpdated: 'Contact updated',
    contactDeleted: 'Contact deleted',
  },
  invoice: {
    search: 'Search invoices',
    create: 'Create new invoice',
    edit: 'Edit invoice',
    delete: 'Delete invoice',
    view: 'View invoice',
    taxPointDate: 'Tax point date',
    taxPointDateMonth: 'Tax point date month',
    dateCreated: 'Date created',
    dateOfPayment: 'Due date',
    dueDate: 'Due Date',
    variableSymbol: 'Variable symbol',
    datePaid: 'Date paid',
    priceWithoutVat: 'Price (without VAT)',
    currency: 'Currency',
    vatPercent: 'VAT (%)',
    vatAmount: 'VAT',
    invoiceNumber: 'Invoice number',
    counterpartyName: 'Counterparty',
    counterpartyCIN: 'CIN',
    bankAccount: 'Bank account',
    direction: 'Direction',
    directions: {
      sales: 'Sales',
      purchase: 'Purchase',
    },
    premierVersion: 'Premier version',
    project: {
      name: 'Project',
    },
    confirm: 'Confirm',
    cancel: 'Cancel',
    saveSuccess: 'Invoice saved',
    expectedAmount: 'Expected amount',
    note: 'Note',
    invoiceStatus: 'Status',
    status: {
      PAID: 'Paid',
      CURRENT: 'Current',
      PAST_DUE: 'Past Due',
    },
    order: 'Order',
    organization: 'Organization',
    type: 'Type',
    types: {
      STANDARD: 'Standard',
      PROFORMA: 'Proforma',
    },
    proformaInvoices: 'Proforma invoices',
    files: 'Files',
    fileNames: 'Files',
    fileUploadError: 'Can not save files',
    maxFileErrorMessage: 'You can not add more than 10 files',
    maxFileSizeErrorMessage: 'Max file size is 30MB',
    dropText: 'Drop files here',
    thisInvoice: 'this invoice',
  },
  all: 'All',
  noDataForSelectedDate: 'No data for selected date',
  noDataForSelectedFilter: 'No data for selected filter',
  showInChart: 'Show in chart',
  yes: 'yes',
  no: 'no',
  searching: 'Searching...',
  noData: 'No data found',
  clearFilter: 'Clear filter',
  deleteDialog: {
    title: 'Delete',
    text: 'Do you really want to delete',
    delete: 'Delete',
  },
  navigateAwayDialog: {
    title: 'Are you sure you want to leave?',
    text: 'Any unsaved changes will be lost.',
  },
  personalSettings: {
    tables: 'Tables',
    table: {
      itemsPerPage: 'Items per page',
    },
  },
  percent: '%',
  md: 'MD',
  h: 'h',
  mdAvgMo: 'MD avg ({monthsCount}mo) | MD avg ({monthsCount}mo) | MD avg ({monthsCount}mo)',
  hAvgMo: 'h avg ({monthsCount}mo) | h avg ({monthsCount}mo) | h avg ({monthsCount}mo)',
  darkMode: 'Dark Mode',
  month: 'Month',
  monthName:
    'January | February | March | April | May | June | July | August | September | October | November | December',
  year: 'Year',
  updated: 'Updated',
  orders: {
    description: 'Description',
    fixedPrice: 'Price',
    priceMustBePositive: 'Price must be a positive number',
    currencyRequired: 'Currency is required',
    id: 'ID',
    timeProgress: 'Time progress',
    setFilterToActive: 'Show active',
    search: 'Search orders',
    create: 'Create new order',
    edit: 'Edit order',
    delete: 'Delete order',
    view: 'View order',
    validFrom: 'Valid from',
    validTo: 'Valid to',
    requestedCapacityFte: 'Requested capacity [FTE]',
    confirmType: 'Confirm type',
    projectName: 'Project',
    state: 'State',
    organizationName: 'Organization',
    stateName: 'State',
    validDateIn: 'Valid in',
    validDateError: "'Valid to' must be greater or equal than 'Valid from'",
    orderTypeRequired: 'Order must be either a sale or a purchase',
    orderExistsError: 'Order with this number already exists',
    confirm: 'Confirm',
    cancel: 'Cancel',
    saveSuccess: 'Order saved',
    note: 'Note',
    states: 'States',
    files: 'Files',
    fileNames: 'Files',
    fileUploadError: 'Can not save files',
    maxFileErrorMessage: 'You can not add more than 10 files',
    maxFileSizeErrorMessage: 'Max file size is 30MB',
    projects: 'Projects',
    dropText: 'Drop files here',
    workType: 'Work type',
    requestedCapacity: 'Requested capacity',
    capacityFte: 'Capacity [FTE]',
    price: 'Price MD',
    currency: 'Currency',
    priceAndCurrencyRequired: 'Price and currency must be filled for work types with FTE capacity',
    name: 'Name',
    isSale: 'Sale',
    isPurchase: 'Purchase',
  },
  roadmapTable: {
    project: 'Project',
    md: 'MD',
    start: 'Start',
    end: 'End',
  },
  companyWorkPerformance: {
    workedTimeExternalProjects: 'Worked time - external projects',
    workedTimeInternalProjects: 'Worked time - internal projects',
    occupancy: 'Occupancy',
    realOccupancy: 'Real Occupancy',
    occupancyThisMonth: 'Occupancy 1st day this month',
    occupancyNextMonth: 'Occupancy 1st day next month',
    paidInvoicesSum: 'Billed without VAT',
    averagePrice: 'Average price',
    averagePriceOverLast3Months:
      'Average price over last {monthsCount} months | Average price over last {monthsCount} months | Average price over last {monthsCount} months',
    help: {
      realOccupancy:
        'Reálné vytížení spočítané jako poměr mezi odpracovanýma hodinama mezi interníma a externíma projektama, dle logů v jiře',
      paidInvoicesSum:
        'Suma fakturovaných částek, dle faktur zaevidovanch v ERP. Nebere se v potaz jejich proplacenost. Pouze INHOUSE projekty, tedy bez OUTSORCE',
      averagePrice: 'Průměrná cena za měsíc, dle fakturovaných částek a odpracovaného času na externích projektech',
    },
  },
  state: {
    name: 'State',
  },
  salesRoadmap: {
    rangePickerLabel: 'Select months',
  },
  homePage: {
    greeting: {
      morning: 'Good morning',
      afternoon: 'Good afternoon',
      evening: 'Good evening',
    },
    kpi: {
      invoices: 'Unpaid invoices overdue',
      bankTransactions: 'Uncategorized payments',
      billableNextMonth: 'Billable next month',
      worklogAnalysis: 'Worklog issues',
      collaboratorsInternal: 'Internal collaborator issues',
      collaboratorsExternal: 'External collaborator issues',
    },
    help: {
      badges: {
        menuItemsBadgesMeaning: 'Menu items badges meaning:',
        invoices: {
          name: 'Invoices:',
          meaning: 'Unpaid invoices overdue count',
        },
        projectPlan: {
          name: 'Collaborator project plan:',
          meaning: 'Occupancy (percent of used collaborator capacity) for the next month',
        },
        projectPlanV2: {
          name: 'Collaborator project plan:',
          meaning: 'Occupancy (percent of used collaborator capacity) for the next month',
        },
        projectCalculation: {
          name: 'Project calculation:',
          meaning: 'Count of projects in last month with costs and unsent report',
        },
        bankTransactionsV2: {
          name: 'Bank transactions:',
          meaning: 'Uncategorized outgoing payments count',
        },
        worklogAnalysis: {
          name: 'Worklog analysis:',
          meaning: 'New worklog issues count',
        },
        collaboratorsInternal: {
          name: 'Internal collaborators:',
          meaning: 'Internal collaborator issues count',
        },
        collaboratorsExternal: {
          name: 'External collaborators:',
          meaning: 'External collaborator issues count',
        },
      },
    },
  },
  ticketTimeCorrection: {
    ticketTimeCorrection: 'Ticket time correction',
    date: 'Date',
    comment: 'Comment',
    timeCorrectionInHours: 'Time correction in hours',
    deleteThisCorrection: 'Delete this correction',
    dateIsRequired: 'Date is required',
    timeCorrectionIsRequired: 'Time correction is required',
    createNewTicketTimeCorrection: 'Create new ticket time correction',
  },
  collaboratorSalesInfo: {
    mdCzkThisMonth: 'CZK/MD this month',
    hCzkThisMonth: 'CZK/h this month',
    mdCzkLastThreeMonths: 'CZK/MD last 3 months',
    hCzkLastThreeMonths: 'CZK/h last 3 months',
    costs: 'Costs',
    salesNotes: 'Sales Notes',
    otherSpecialistsAveragesWithSamePosition: 'Other specialists averages with same position',
    collaboratorPriceWarning:
      'This price is under or equal (avg position price +20%). You won’t be probably able to replace this specialist for the current price.',
    collaboratorPriceOk: 'This price is above (avg position price +20%).',
  },
  collaboratorCapacityReport: {
    showCollaborators: 'Show collaborators',
    occupancy: 'Occupancy',
    filter: {
      showingItemOfItems: 'Showing {visibleItemsCount} of {itemsCount}, filter applied:',
      availableCapacity: 'available capacity >= {capacity}MD',
      skillValue: 'skill value >= {skill}',
      department: 'department = {department}',
      minAvailableCapacity: 'Minimum available capacity:',
      minSkillValue: 'Minimum skill value:',
    },
    moneyMode: 'Financial view',
    lostRevenue: 'Unrealized revenue',
    unusedCapacity: 'Unused capacity: {md} MD',
    czk: 'CZK',
    md: 'MD',
    annualStatusTooltip: {
      title: 'Monthly occupancy',
      totals: 'Available: {total} · Used: {used} · Unused: {unused}',
      calculation: 'Occupancy = used / available = {used} / {total} = {occupancy}',
      indicatorMatched: 'Indicator {icon} selected (threshold ≥ {limit}, occupancy {occupancy})',
      noIndicatorMatched: 'No indicator threshold reached',
    },
  },
  agGridOptionsSidebar: {
    expandHideRows: 'Epand / hide rows',
    changePagination: 'Number of rows per page',
    savePersonalSettings: 'Save table settings',
    resetColumns: 'Reset columns',
    columnsSettings: 'Columns settings',
    export: 'Export',
    downloadCsv: 'Download CSV',
    downloadExcel: 'Download EXCEL',
    fixedCols: 'Set columns automatically',
    options: 'Option',
  },
  majorSkills: 'Major skills',
  juniorSkills: 'Junior skills',
  mediorSkills: 'Medior skills',
  seniorSkills: 'Senior skills',
  profileLink: 'Profile link',
  info: 'Info',
  notes: 'Notes',
  id: 'ID',
  skills: 'Skills',
  note: 'Note',
  corrections: 'Corrections',
  fileInput: {
    deleteAllFiles: 'Do you really want to delete all files',
  },
  cEditableTable: {
    create: 'Create item',
    disabled: 'Inputs are invalid',
  },
  cEditableRowItem: {
    deleteItem: 'Delete item',
  },
  checked: 'Checked',
  next: 'next',
  prev: 'prev',
  accessDenied: 'Access denied',
  department: 'Department',
  currentCompany: 'Company',
  language: 'Language',
  tooltips: {
    skillHeatmap: {
      skill: 'Skill:',
      value: 'Value:',
    },
  },
  personalSettingsPage: {
    personalSettings: 'Personal Settings',
    userProfile: 'User Profile',
    socketEvents: 'Socket events',
    idToken: 'ID token',
    tabs: {
      language: 'Language',
      debug: 'Debug Info',
    },
    languageSettings: 'Language Settings',
  },
  collaboratorProfilesPage: {
    selectFirst: 'Please select a collaborator first',
    save: 'Save',
    lastEdit: 'Last edit',
    by: 'by',
    skillsOutdatedBannerDays: "Don't forget to check the collaborator's skills — last update was {days} days ago.",
    skillsOutdatedBannerNever: "This collaborator's skills have never been updated.",
    openSkills: 'Open skills',
    baseInfo: 'Base info',
    collaboratorId: 'Collaborator ID:',
    experience: 'number of years of experience',
    willingnessToLeadTeam: 'willingness to lead the team',
    experienceInLeadingTeam: 'experience in leading a team',
    skills: 'Skills',
    other: 'Other',
    projects: 'Projects',
    strengthsWeaknesses: 'Strengths and weaknesses',
    otherTechnologies: 'Other technologies',
    workedMD: 'worked MD:',
    monthsOnProject: 'months on project:',
    certifications: 'Certifications',
    profileUrl: 'Profile URL',
    designAndArchitecture: {
      softwareArchitecture: 'Design the architecture of software systems',
      databaseArchitecture: 'Design the architecture of databases',
      technologySelection: 'Select appropriate technologies for projects',
      technicalLeadership: 'Lead technical teams to success',
    },
    development: {
      frontend: 'Work on the frontend of applications',
      backend: 'Work on the backend of applications',
      database: 'Manage and maintain databases',
      api: 'Develop and maintain APIs',
    },
    testingAndQA: {
      unitTesting: 'Write and run unit tests',
      e2eTesting: 'Perform end-to-end testing',
      codeReview: 'Review and approve code changes',
      bugFixing: 'Fix bugs and issues in the code',
    },
    maintenance: {
      refactoring: 'Improve existing code through refactoring',
      support: 'Provide support for the system',
    },
    collaborationAndCommunication: {
      customerCommunication: 'Communicate with customers and clients',
      teamCollaboration: 'Collaborate with the team',
      documentation: 'Create and update documentation',
    },
    projectManagement: {
      estimationAndPlanning: 'Estimate time and resources for projects',
      taskManagement: 'Manage and assign tasks',
      monitoringAndReporting: 'Monitor progress and generate reports',
    },
  },
  layout: {
    instanceTypeWarning: '⚠️ This is not a production instance ⚠️',
    impersonationWarning: '⚠️ You are logged in as another user ⚠️',
  },
  menu: {
    home: 'Home',
    settings: 'Settings',
    personalSettings: 'Personal Settings',
    favorites: 'Favorites',
    sales: 'Sales',
    projects: 'Projects',
    hr: 'HR',
    finance: 'Finance',
    planning: 'Planning',
    analysis: 'Analysis',
    organizations: 'Organizations',
    orders: 'Orders',
    availableCapacityReport: 'Available capacity report',
    ordersRoadmap: 'Orders roadmap',
    salesProjectsStatistics: 'Sales projects statistics',
    collaboratorProfiles: 'Collaborator Profiles',
    projectsList: 'Projects list',
    projectCalculation: 'Project calculation',
    projectOverview: 'Project overview',
    worklogTimesheet: 'Worklog Timesheet',
    collaboratorsInternal: 'Internal collaborators',
    collaboratorsExternal: 'External collaborators',
    collaboratorSkills: 'Collaborator skills',
    bankTransactionsV2: 'Bank transactions',
    collaboratorCostsInternal: 'Internal collaborator costs',
    collaboratorCostsExternal: 'External collaborator costs',
    costsPlanning: 'Costs planning',
    companyProfit: 'Company profit',
    invoices: 'Invoices',
    assets: 'Assets',
    projectOverallCalculation: 'Project overall calculation',
    worklogAnalysis: 'Worklog analysis',
    costsAnalysis: 'Costs analysis',
    companyProfitAnalysis: 'Company profit analysis',
    estimateAnalysis: 'Estimate analysis',
    collaboratorWorkPlan: 'Collaborator work plan',
    projectPlanV2: 'Collaborator project plan',
    collaboratorStats: 'Collaborator stats',
    collaboratorProfit: 'Collaborator profit',
    aiChatV2: 'AI Chat',
  },
  menuDescriptions: {
    home: 'Dashboard providing a comprehensive overview of key company performance indicators, recent activities, and important system notifications.',
    settings:
      'Global application configuration, including system-wide parameters, permission management, and general settings.',
    personalSettings:
      'Manage your individual user profile, display preferences, table settings, and personal account security.',
    organizations:
      'Complete database of partner organizations, clients, and suppliers, including contact details and related projects.',
    orders: 'Comprehensive list of all client orders, tracking their lifecycle from initial agreement to completion.',
    availableCapacityReport:
      'Visual report of collaborator availability across the company, enabling efficient resource allocation based on skills and workload.',
    ordersRoadmap:
      'Interactive timeline showing the distribution of orders over time, facilitating long-term planning and capacity forecasting.',
    salesProjectsStatistics:
      'In-depth financial analysis of sales-oriented projects, comparing revenues, costs, and overall profitability margins.',
    collaboratorProfiles:
      'Detailed repository of collaborator expertise, certifications, project history, and professional development records.',
    projectsList:
      'Central registry of all internal and external projects, providing a high-level view of their current status and responsible managers.',
    projectCalculation:
      'Granular financial breakdown of a specific project, including detailed worklog costs, additional expenses, and revenue tracking.',
    projectOverview:
      'Detailed dashboard for a single project, aggregating essential information, team members, and overall project health indicators.',
    worklogTimesheet:
      'Personalized view for recording and reviewing daily work activities, ensuring accurate time tracking.',
    collaboratorsInternal:
      'Database and management interface for internal collaborators, covering personal details, positions, and company history.',
    collaboratorsExternal:
      'Management of external partners, contractors, and freelancers, tracking their engagement and administrative details.',
    collaboratorSkills:
      'A central matrix of skills and competencies across the team, used for project matching and identifying training needs.',
    bankTransactions: 'Integrated view of company bank accounts, allowing for easy categorization of payments.',
    collaboratorCostsInternal:
      'Detailed analysis of costs associated with internal collaborators, including wages and bonuses.',
    collaboratorCostsExternal: 'Tracking and management of costs related to external contractors.',
    costsPlanning:
      'Strategic planning tool for monthly operating expenses and other non-project related company costs.',
    companyProfit:
      'High-level financial overview of company performance, consolidating revenues and costs to show real-time profitability.',
    invoices:
      'Comprehensive management of issued and received invoices, including payment tracking, VAT details, and digital archiving.',
    assets: 'Inventory tracking system for company hardware, and other equipment assigned to collaborators.',
    projectOverallCalculation:
      'Consolidated financial report across multiple projects, enabling cross-project comparison and aggregate performance analysis.',
    worklogAnalysis:
      'Analytical tool for reviewing worklog patterns, identifying bottlenecks, and optimizing team efficiency.',
    costsAnalysis:
      'Advanced visualization and breakdown of company costs by categories, subcategories, and time periods.',
    companyProfitAnalysis:
      'Historical analysis of company profit trends, providing insights for long-term financial planning and strategy.',
    collaboratorWorkPlan:
      'Scheduling interface for defining collaborator work availability, vacations, and planned capacity.',
    collaboratorProjectPlan:
      'Strategic tool for assigning collaborators to specific projects based on their planned capacity and project requirements.',
    collaboratorStats:
      'Analytical report providing insights into collaborator headcount, distribution across departments, and historical trends.',
    collaboratorProfit: 'Overview of profit generated per collaborator across projects.',
    googleDocument: '-',
  },
  collaboratorProfit: {
    filterDates: 'Date range',
    filterUser: 'Collaborator',
    all: 'All',
    internal: 'Internal',
    external: 'External',
    collaborator: 'Collaborator',
    type: 'Type',
    position: 'Position',
    workedHours: 'Worked hours',
    billedHours: 'Billed hours',
    unbilledHours: 'Unbilled hours',
    totalCosts: 'Total costs',
    totalRevenue: 'Total revenue',
    marginCzk: 'Margin',
    marginPercent: 'Margin',
    project: 'Project',
  },
  worklogTimesheet: {
    hello: 'Hello world',
    selectUser: 'Select collaborator',
    selectProject: 'Select project',
    collaboratorMode: 'Collaborators',
    projectMode: 'Projects',
    from: 'From',
    to: 'To',
    sum: 'Sum',
    thisWeek: 'This week',
    prevWeek: 'Previous week',
    thisMonth: 'This month',
    prevMonth: 'Previous month',
    dateRangeMax6Months: 'Date range cannot exceed 6 months',
    dateRangeInvalid: "'To' date must be after or equal to 'From' date",
  },
  aiChatV2: {
    title: 'AI Chat',
    homeSearchPlaceholder: 'Ask AI...',
    newConversation: 'New conversation',
    placeholder: 'Write a message…',
    deleteConfirm: 'Delete this conversation?',
    delete: 'Delete',
    sessionActions: 'Options',
    rename: 'Rename',
    renamePlaceholder: 'Conversation name',
    reloginRequired: 'Please sign in again',
    connection: {
      connected: 'Connected',
      connecting: 'Connecting…',
      disconnected: 'Disconnected — click to reconnect',
    },
    emptySidebar: 'No conversations yet',
    loadingSessions: 'Loading conversations…',
    thinking: 'Thinking…',
    responding: 'Generating response…',
    usingTool: 'Using tool:',
    startConversation: 'Start a new conversation',
    toolCall: 'Tool call',
    toolResult: 'Tool result',
    toolError: 'error',
    showToolBlocks: 'Show tool calls and results',
    hideToolBlocks: 'Hide tool calls and results',
    settings: 'Settings',
    modelLabel: 'Model',
    thinkingLabel: 'Thinking',
    thinkingLevel: 'Thinking level: {level}',
    thinkingLevels: {
      serverDefault: 'Default (server)',
      off: 'Off',
      low: 'Low',
      medium: 'Medium',
      high: 'High',
    },
    models: {
      serverDefault: 'Default model',
    },
    fullMessage: 'Full message',
    fullMessagePreview: 'Preview',
    fullMessageMarkdown: 'Markdown',
    viewFullMessage: 'View full message',
    copyMessage: 'Copy',
    messageCopied: 'Copied!',
    prompts: {
      button: 'Saved prompts',
      title: 'Saved prompts',
      empty: 'No saved prompts yet. Save a question you send repeatedly.',
      noResults: 'Nothing found.',
      new: 'New prompt',
      saveCurrent: 'Save current text',
      edit: 'Edit',
      delete: 'Delete',
      search: 'Search prompts…',
      dialogTitle: 'Saved prompt',
      name: 'Name',
      text: 'Prompt text',
      nameTaken: 'You already have a prompt with this name.',
    },
  },
};
